import type { AnswerAidProps } from '@/features/flashcards/utils/contentFormatters';
import type { NoteMetadata } from '../types/music';
import { NameItInput } from './NameItInput';
import { PianoKeyboard } from './PianoKeyboard';

/**
 * Optional input aid shown while a music-notation card is unflipped.
 * Tapping any control only reveals the answer (flips the card) — the
 * student self-grades with the standard Easy/Med/Hard buttons afterward,
 * so the tapped value is intentionally ignored.
 */
export function MusicAnswerAid({ card, onReveal }: AnswerAidProps) {
  const meta = card.front.content_metadata as NoteMetadata | undefined;
  const mode = meta?.answer_mode;

  if (mode === 'name') {
    return <NameItInput onAnswer={() => onReveal()} />;
  }

  if (mode === 'find') {
    const midi = meta?.midi ?? 60;
    return <PianoKeyboard lowMidi={midi - 5} highMidi={midi + 6} onKey={() => onReveal()} />;
  }

  return null;
}
